import { Pipe, PipeTransform } from '@angular/core';
import { HashMap } from '@ngneat/transloco';
import { SelectOption } from '../inputs/select/model/select-option';

@Pipe({
  name: 'translateLabels'
})
export class TranslateLabelsPipe implements PipeTransform {

  transform(options: SelectOption[], translocoFunction: (key: string, params?: HashMap) => any): SelectOption[] {
    return options.map(option => ({value: option.value, label: translocoFunction(option.label.toString())}));
  }

}
